import {IUsefulLink, UsefulLinkRenderOptions} from "./useful-link.interface";
import React, {ReactNode} from "react";
import {IUsefulLinkSdkData} from "./useful-link-data.interface";
import {UsefulLinksItemBox} from '../../../components/useful-links/boxes/useful-links-item/useful-links-item.box';
import {UsefulLinksItemSideTextBox} from "../../../components/useful-links/boxes/useful-links-item/useful-links-item-side-text.box";

type ActivatorType = (IUsefulLinkSdkData) => void;

export class SdkUsefulLink implements IUsefulLink {
  private readonly activator: ActivatorType;
  private readonly linkConfig: IUsefulLinkSdkData;

  constructor(activator: ActivatorType, link: IUsefulLinkSdkData) {
    this.activator = activator;
    this.linkConfig = link;
  }

  render(options: UsefulLinkRenderOptions): ReactNode {
    return (
      <UsefulLinksItemBox key={this.linkConfig.id} className='cy-useful-links-item'
          onClick={() => {
              if(options.onClick) {
                  options.onClick();
              }
              this.activator(this.linkConfig);
          }}>
        {this.linkConfig.translation}
          {this.linkConfig.sideText && <UsefulLinksItemSideTextBox className={this.linkConfig.sideTextClass || ''}>{this.linkConfig.sideText}</UsefulLinksItemSideTextBox>}
      </UsefulLinksItemBox>
    );
  }
}
